import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../../constants/constants';
import { useAppSelector } from '../../../redux/store';
import { Rect } from '../pixiComponents/rect';
export const MySeatBackgroundContainer = () => {
    const bounds = useAppSelector((state) => {
        if (state.poker.mySeatIndex === undefined) {
            return;
        }
        return state.gameDimensions.allSeatBounds[state.poker.mySeatIndex];
    }, shallowEqual);
    if (bounds === undefined) {
        return null;
    }
    return (_jsx(Container, { x: bounds.x, y: bounds.y, children: _jsx(Rect, { x: -bounds.w / 2, y: -bounds.h / 2, w: bounds.w, h: bounds.h, lineColor: 0xffffff, lineWidth: 6, radius: POKER_SEAT_ROUNDED_RECT_RADIUS, lineAlpha: 0.2 }) }));
};
